/**
 * @file swap订单相关API
 */
import { SwapTxType, SwapOrderStatus } from '@/constants';
import { get, post, WalletChainTypes } from '@web3/base-utils';

export type SwapChain = {
  /** 链ID */
  chainId: number;
  /** 链Code */
  chainCode: string;
  /** 链名称 */
  chainName: string;
  /** 链类型 */
  chainType: WalletChainTypes;
  /** 排序 */
  order: number;
};

// 獲取swap支援的chains
export const getSwapChainListApi = () => {
  return get<SwapChain[]>('/spot/api/web3/swap/v3/chains');
};

// 获取swap订单记录
export type GetSwapOrderListParams = {
  chainId?: number;
  direct?: number;
  offsetId?: number;
  offsetLimit: number;
  walletAddresses?: Array<{
    chainId: number;
    walletAddress: string;
  }>;
};

export type SwapOrderDetail = {
  type: SwapTxType;
  fromTokenSymbol: string;
  toTokenSymbol: string;
  txExplorerUrl: string;
  txHash: string;
  chainId: number;
  chainName: string;
  chainIconUrl: string;
  fromAddress: string;
  toAddress: string;
  actualGasFeeAmount: string;
  status: SwapOrderStatus;
};

export type SwapOrder = {
  id: number;
  fromToken: {
    symbol: string;
    iconUri: string;
  };
  createdAt: number;
  fromChainIconUrl: string;
  fromTokenAmount: string;
  toToken: {
    symbol: string;
    iconUri: string;
  };
  toChainIconUrl: string;
  toTokenAmount: string;
  feeAmount: string;
  orderId: string;
  status: SwapOrderStatus;
  orderTransactions: Array<SwapOrderDetail>;
};
export const getSwapOrderListApi = (params: GetSwapOrderListParams) => {
  return post<{
    orders: SwapOrder[];
    total: string;
  }>('/spot/api/web3/swap/v3/listDecOrders', params);
};
